import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const hasFuture = (state: RootState) => state.pages.editor.documents.future.length > 0;

const getCanRedo = createSelector([hasFuture], (canRedo) => canRedo);

export default getCanRedo;
